/* Fitment "View Details" zoom lightbox.
   Self-contained, no deps. Binds ONE delegated click listener on document
   (guarded so it only binds once even if the section re-renders).
   A click on a [data-fitment-zoom] control opens an overlay with the larger
   option image; it never selects the underlying radio option. */
(function () {
  'use strict';
  if (window.__fitmentLightboxBound) return;
  window.__fitmentLightboxBound = true;

  var overlay = null;
  var imgEl = null;
  var closeBtn = null;
  var prevBtn = null;
  var nextBtn = null;
  var counterEl = null;
  var frameEl = null;
  var lastFocused = null;

  // Gallery mode (client feedback round 2, item 1): when the lightbox is opened
  // from the main product image it holds the whole gallery, so the shopper can
  // step through the images with the arrows, the keyboard or a swipe instead of
  // closing and reopening. The variant "View details" images stay single.
  var items = null; // [{src, alt}] or null in single-image mode
  var index = 0;

  function upscaleSrc(src) {
    // Bump the Shopify CDN size for a sharper image when a width param is present.
    if (!src) return src;
    if (/([?&])width=400(\b|&|$)/.test(src)) {
      return src.replace(/([?&])width=400(\b)/, '$1width=1200');
    }
    return src;
  }

  function buildOverlay() {
    overlay = document.createElement('div');
    overlay.className = 'fitment-lightbox';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Option image');

    imgEl = document.createElement('img');
    imgEl.className = 'fitment-lightbox-img';
    imgEl.setAttribute('alt', '');

    closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'fitment-lightbox-close';
    closeBtn.setAttribute('aria-label', 'Close');
    closeBtn.innerHTML = '×';

    // Chevrons are SVG, not the ‹ › glyphs: those carry asymmetric side bearings,
    // so they never sit optically centred in a round button however the box is
    // aligned (client feedback round 2).
    var chevron = function (dir) {
      return (
        '<svg viewBox="0 0 24 24" width="24" height="24" fill="none" aria-hidden="true" focusable="false">' +
        '<path d="' + (dir < 0 ? 'M15 5 8 12l7 7' : 'M9 5l7 7-7 7') + '" ' +
        'stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
      );
    };

    prevBtn = document.createElement('button');
    prevBtn.type = 'button';
    prevBtn.className = 'fitment-lightbox-nav fitment-lightbox-prev';
    prevBtn.setAttribute('aria-label', 'Previous image');
    prevBtn.innerHTML = chevron(-1);

    nextBtn = document.createElement('button');
    nextBtn.type = 'button';
    nextBtn.className = 'fitment-lightbox-nav fitment-lightbox-next';
    nextBtn.setAttribute('aria-label', 'Next image');
    nextBtn.innerHTML = chevron(1);

    counterEl = document.createElement('div');
    counterEl.className = 'fitment-lightbox-counter';

    // The arrows live in a frame that shrink-wraps the image so they can be
    // positioned against the PHOTO: beside it on desktop, on top of it (inset
    // 20px) on mobile, where viewport-anchored arrows hung off the photo's edges.
    // The counter stays a sibling of the frame so it sits BELOW the photo.
    frameEl = document.createElement('div');
    frameEl.className = 'fitment-lightbox-frame';
    frameEl.appendChild(imgEl);
    frameEl.appendChild(prevBtn);
    frameEl.appendChild(nextBtn);

    overlay.appendChild(frameEl);
    overlay.appendChild(counterEl);
    overlay.appendChild(closeBtn);
    document.body.appendChild(overlay);

    closeBtn.addEventListener('click', close);
    prevBtn.addEventListener('click', function () { step(-1); });
    nextBtn.addEventListener('click', function () { step(1); });
    overlay.addEventListener('click', function (e) {
      // Close only when the backdrop (not the image or a control) is clicked,
      // and never on the click a swipe synthesises.
      if (e.target !== overlay && e.target !== frameEl) return;
      if (Date.now() - lastSwipeAt < 500) return;
      close();
    });

    bindSwipe();
  }

  // Horizontal swipe over the image steps through the gallery.
  var swipe = null;
  var lastSwipeAt = 0;
  function bindSwipe() {
    overlay.addEventListener(
      'touchstart',
      function (e) {
        swipe = e.touches[0] ? { x: e.touches[0].clientX, y: e.touches[0].clientY } : null;
      },
      { passive: true }
    );
    overlay.addEventListener(
      'touchend',
      function (e) {
        var st = swipe;
        swipe = null;
        if (!st || !items || items.length < 2 || !e.changedTouches[0]) return;
        var dx = e.changedTouches[0].clientX - st.x;
        var dy = e.changedTouches[0].clientY - st.y;
        if (Math.abs(dx) < 40 || Math.abs(dx) <= Math.abs(dy)) return;
        lastSwipeAt = Date.now();
        step(dx < 0 ? 1 : -1);
      },
      { passive: true }
    );
  }

  function step(dir) {
    if (!items || items.length < 2) return;
    show((index + dir + items.length) % items.length);
  }

  function show(i) {
    index = i;
    var item = items[i];
    imgEl.src = item.src;
    imgEl.setAttribute('alt', item.alt || '');
    counterEl.textContent = i + 1 + ' / ' + items.length;
    // Preload the neighbours so stepping is instant.
    [items[(i + 1) % items.length], items[(i - 1 + items.length) % items.length]].forEach(
      function (n) {
        if (n) new Image().src = n.src;
      }
    );
  }

  function setNavVisible(on) {
    var display = on ? '' : 'none';
    prevBtn.style.display = display;
    nextBtn.style.display = display;
    counterEl.style.display = display;
  }

  function open(src, alt) {
    if (!overlay) buildOverlay();
    lastFocused = document.activeElement;
    items = null;
    setNavVisible(false);
    imgEl.src = upscaleSrc(src) || src;
    imgEl.setAttribute('alt', alt || '');
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    closeBtn.focus();
  }

  function openGallery(list, startIndex) {
    if (!overlay) buildOverlay();
    lastFocused = document.activeElement;
    items = list;
    setNavVisible(list.length > 1);
    show(startIndex);
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    closeBtn.focus();
  }

  function close() {
    if (!overlay) return;
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    imgEl.removeAttribute('src');
    items = null;
    if (lastFocused && typeof lastFocused.focus === 'function') {
      lastFocused.focus();
    }
    lastFocused = null;
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-fitment-zoom]');
    if (!trigger) return;
    // Don't toggle the radio / submit the form.
    e.preventDefault();
    e.stopPropagation();
    open(trigger.getAttribute('data-zoom-src'), trigger.getAttribute('data-zoom-alt'));
  });

  // Main product image opens in this same lightbox (single centered image on a
  // dark backdrop) instead of the theme's stacked gallery modal, matching the
  // variant "View details" option-image behaviour (Asana style-updates item 2).
  // Capture phase + stopPropagation so <modal-opener> never opens its modal.
  document.addEventListener(
    'click',
    function (e) {
      var opener = e.target.closest('.product-modal-opener');
      if (!opener) return;
      // Only the main gallery image (not thumbnails, videos or 3D models).
      if (!opener.classList.contains('product-modal-opener-image')) return;
      if (!opener.closest('.product-media-main-wrapper')) return;

      var img = opener.querySelector('img');
      if (!img) return;

      e.preventDefault();
      e.stopPropagation();

      // Collect the whole gallery so the shopper can swipe/step between images.
      // Only the media actually rendered on the page are in the DOM — with the
      // section's `hide_variants` setting on, other variants' images are never
      // output (see snippets/product-media-gallery.liquid) — so this is exactly
      // the set the on-page gallery offers.
      var wrapper = opener.closest('.product-media-main-wrapper');
      var imgs = wrapper
        ? Array.prototype.slice.call(
            wrapper.querySelectorAll('.product-modal-opener-image img')
          )
        : [img];
      var list = imgs.map(function (el) {
        return {
          src: (el.currentSrc || el.src).replace(/([?&])width=\d+/, '$1width=1600'),
          alt: el.getAttribute('alt') || ''
        };
      });
      var start = imgs.indexOf(img);
      openGallery(list, start < 0 ? 0 : start);
    },
    true
  );

  document.addEventListener('keydown', function (e) {
    if (!overlay || !overlay.classList.contains('is-open')) return;
    if (e.key === 'Escape' || e.key === 'Esc') {
      close();
    } else if (e.key === 'ArrowRight') {
      e.preventDefault();
      step(1);
    } else if (e.key === 'ArrowLeft') {
      e.preventDefault();
      step(-1);
    }
  });
})();
